<template>
<div class="upload-page">

    <!-- Header -->
    <b-card no-body class="upload-header-card mb-1">
      <b-card-body class="d-flex align-items-center">
        <div class="icon-header mr-1">
          <feather-icon icon="UploadCloudIcon" size="22" />
        </div>
        <div>
          <h4 class="mb-0">Importar datos CSV</h4>
          <small class="text-muted">Sube archivos CSV para actualizar ventas, stock, URLs y medidas</small>
        </div>
      </b-card-body>
    </b-card>

    <!-- Venta Mensual -->
    <b-card no-body class="upload-card mb-1">
      <b-card-header class="upload-card-header">
        <div class="d-flex align-items-center">
          <div class="upload-icon upload-icon-ventas mr-1">
            <feather-icon icon="TrendingUpIcon" size="18" />
          </div>
          <div>
            <h5 class="mb-0">Venta Mensual</h5>
            <small class="text-muted" v-if="lastUpdateVentaMensual">
              Ultima actualización: <b-badge variant="light-primary" pill>{{ lastUpdateVentaMensual }}</b-badge>
            </small>
          </div>
        </div>
      </b-card-header>
      <b-card-body class="pt-1">
        <b-row class="align-items-center">
          <b-col cols="12" md="9">
            <b-form-file
              v-model="csvInput"
              placeholder="Selecciona un archivo CSV o arrástralo aquí..."
              drop-placeholder="Suelta el archivo aquí..."
              class="upload-file-input"
            />
          </b-col>
          <b-col cols="12" md="3" class="mt-1 mt-md-0">
            <b-button variant="primary" block @click="addVentaMensual" class="upload-btn">
              <feather-icon icon="UploadIcon" size="16" class="mr-50" />
              Procesar
            </b-button>
          </b-col>
        </b-row>
        <div class="text-center mt-1">
          <span class="btn-ejemplo" @click="viewSampleVentaMensual = !viewSampleVentaMensual">
            <feather-icon :icon="viewSampleVentaMensual ? 'ChevronUpIcon' : 'ChevronDownIcon'" size="14" class="mr-25" />
            Ver ejemplo
          </span>
        </div>
        <div v-if="viewSampleVentaMensual" class="sample-section mt-1">
          <b-table responsive="sm" :items="itemsSampleVentaMensual" striped small class="sample-table" />
          <div class="text-center">
            <b-button variant="flat-primary" size="sm" @click="downloadTemplateVentaMensual">
              <feather-icon icon="DownloadIcon" size="14" class="mr-50" />
              Descargar plantilla
            </b-button>
          </div>
        </div>
      </b-card-body>
    </b-card>

    <!-- Venta Diaria (oculto) -->
    <b-card no-body class="upload-card mb-1" v-if="false">
      <b-card-header class="upload-card-header">
        <div class="d-flex align-items-center">
          <div class="upload-icon upload-icon-ventas mr-1">
            <feather-icon icon="BarChart2Icon" size="18" />
          </div>
          <div>
            <h5 class="mb-0">Venta Diaria</h5>
            <small class="text-muted" v-if="lastUpdateVentaDiaria">
              Ultima actualización: <b-badge variant="light-primary" pill>{{ lastUpdateVentaDiaria }}</b-badge>
            </small>
          </div>
        </div>
      </b-card-header>
      <b-card-body class="pt-1">
        <b-row class="align-items-center">
          <b-col cols="12" md="9">
            <b-form-file
              v-model="csvVentaDiaria"
              placeholder="Selecciona un archivo CSV o arrástralo aquí..."
              drop-placeholder="Suelta el archivo aquí..."
              class="upload-file-input"
            />
          </b-col>
          <b-col cols="12" md="3" class="mt-1 mt-md-0">
            <b-button variant="primary" block @click="addVentaDiaria" class="upload-btn">
              <feather-icon icon="UploadIcon" size="16" class="mr-50" />
              Procesar
            </b-button>
          </b-col>
        </b-row>
        <div class="text-center mt-1">
          <span class="btn-ejemplo" @click="viewSampleVentaDiaria = !viewSampleVentaDiaria">
            <feather-icon :icon="viewSampleVentaDiaria ? 'ChevronUpIcon' : 'ChevronDownIcon'" size="14" class="mr-25" />
            Ver ejemplo
          </span>
        </div>
        <div v-if="viewSampleVentaDiaria" class="sample-section mt-1">
          <b-table responsive="sm" :items="itemsSampleVentaDiaria" striped small class="sample-table" />
          <div class="text-center">
            <b-button variant="flat-primary" size="sm" @click="downloadTemplateVentaDiaria">
              <feather-icon icon="DownloadIcon" size="14" class="mr-50" />
              Descargar plantilla
            </b-button>
          </div>
        </div>
      </b-card-body>
    </b-card>

    <!-- Visita Diaria (oculto) -->
    <b-card no-body class="upload-card mb-1" v-if="false">
      <b-card-header class="upload-card-header">
        <div class="d-flex align-items-center">
          <div class="upload-icon upload-icon-visitas mr-1">
            <feather-icon icon="EyeIcon" size="18" />
          </div>
          <div>
            <h5 class="mb-0">Visita Diaria</h5>
            <small class="text-muted" v-if="lastUpdateVisitaDiaria">
              Ultima actualización: <b-badge variant="light-info" pill>{{ lastUpdateVisitaDiaria }}</b-badge>
            </small>
          </div>
        </div>
      </b-card-header>
      <b-card-body class="pt-1">
        <b-row class="align-items-center">
          <b-col cols="12" md="9">
            <b-form-file
              v-model="csvVisitaDiaria"
              placeholder="Selecciona un archivo CSV o arrástralo aquí..."
              drop-placeholder="Suelta el archivo aquí..."
              class="upload-file-input"
            />
          </b-col>
          <b-col cols="12" md="3" class="mt-1 mt-md-0">
            <b-button variant="primary" block @click="addVisitaDiaria" class="upload-btn">
              <feather-icon icon="UploadIcon" size="16" class="mr-50" />
              Procesar
            </b-button>
          </b-col>
        </b-row>
        <div class="text-center mt-1">
          <span class="btn-ejemplo" @click="viewSampleVisitaDiaria = !viewSampleVisitaDiaria">
            <feather-icon :icon="viewSampleVisitaDiaria ? 'ChevronUpIcon' : 'ChevronDownIcon'" size="14" class="mr-25" />
            Ver ejemplo
          </span>
        </div>
        <div v-if="viewSampleVisitaDiaria" class="sample-section mt-1">
          <b-table responsive="sm" :items="itemsSampleVisitaDiaria" striped small class="sample-table" />
          <div class="text-center">
            <b-button variant="flat-primary" size="sm" @click="downloadTemplateVisitaDiaria">
              <feather-icon icon="DownloadIcon" size="14" class="mr-50" />
              Descargar plantilla
            </b-button>
          </div>
        </div>
      </b-card-body>
    </b-card>

    <!-- Visitas Mensuales (oculto) -->
    <b-card no-body class="upload-card mb-1" v-if="false">
      <b-card-header class="upload-card-header">
        <div class="d-flex align-items-center">
          <div class="upload-icon upload-icon-visitas mr-1">
            <feather-icon icon="ActivityIcon" size="18" />
          </div>
          <div>
            <h5 class="mb-0">Visitas Mensuales</h5>
            <small class="text-muted" v-if="lastUpdateVisitasMensuales">
              Ultima actualización: <b-badge variant="light-info" pill>{{ lastUpdateVisitasMensuales }}</b-badge>
            </small>
          </div>
        </div>
      </b-card-header>
      <b-card-body class="pt-1">
        <b-row class="align-items-center">
          <b-col cols="12" md="9">
            <b-form-file
              v-model="csvVisitaMensual"
              placeholder="Selecciona un archivo CSV o arrástralo aquí..."
              drop-placeholder="Suelta el archivo aquí..."
              class="upload-file-input"
            />
          </b-col>
          <b-col cols="12" md="3" class="mt-1 mt-md-0">
            <b-button variant="primary" block @click="addVisitaMensual" class="upload-btn">
              <feather-icon icon="UploadIcon" size="16" class="mr-50" />
              Procesar
            </b-button>
          </b-col>
        </b-row>
        <div class="text-center mt-1">
          <span class="btn-ejemplo" @click="viewSampleVisitasMensuales = !viewSampleVisitasMensuales">
            <feather-icon :icon="viewSampleVisitasMensuales ? 'ChevronUpIcon' : 'ChevronDownIcon'" size="14" class="mr-25" />
            Ver ejemplo
          </span>
        </div>
        <div v-if="viewSampleVisitasMensuales" class="sample-section mt-1">
          <b-table responsive="sm" :items="itemsSampleVisitasMensuales" striped small class="sample-table" />
          <div class="text-center">
            <b-button variant="flat-primary" size="sm" @click="downloadTemplateVisitaMensuales">
              <feather-icon icon="DownloadIcon" size="14" class="mr-50" />
              Descargar plantilla
            </b-button>
          </div>
        </div>
      </b-card-body>
    </b-card>

    <!-- Stock Noviembre -->
    <b-card no-body class="upload-card mb-1">
      <b-card-header class="upload-card-header">
        <div class="d-flex align-items-center">
          <div class="upload-icon upload-icon-stock mr-1">
            <feather-icon icon="PackageIcon" size="18" />
          </div>
          <div>
            <h5 class="mb-0">Stock Noviembre</h5>
            <small class="text-muted" v-if="lastUpdateStockMensual">
              Ultima actualización: <b-badge variant="light-success" pill>{{ lastUpdateStockMensual }}</b-badge>
            </small>
          </div>
        </div>
      </b-card-header>
      <b-card-body class="pt-1">
        <b-row class="align-items-center">
          <b-col cols="12" md="9">
            <b-form-file
              v-model="csvStockMensual"
              placeholder="Selecciona un archivo CSV o arrástralo aquí..."
              drop-placeholder="Suelta el archivo aquí..."
              class="upload-file-input"
            />
          </b-col>
          <b-col cols="12" md="3" class="mt-1 mt-md-0">
            <b-button variant="success" block @click="addStockMensual" class="upload-btn">
              <feather-icon icon="UploadIcon" size="16" class="mr-50" />
              Procesar
            </b-button>
          </b-col>
        </b-row>
        <div class="text-center mt-1">
          <span class="btn-ejemplo" @click="viewSampleStockMensual = !viewSampleStockMensual">
            <feather-icon :icon="viewSampleStockMensual ? 'ChevronUpIcon' : 'ChevronDownIcon'" size="14" class="mr-25" />
            Ver ejemplo
          </span>
        </div>
        <div v-if="viewSampleStockMensual" class="sample-section mt-1">
          <b-table responsive="sm" :items="itemsSampleStockMensuales" striped small class="sample-table" />
          <div class="text-center">
            <b-button variant="flat-primary" size="sm" @click="downloadTemplateStockMensual">
              <feather-icon icon="DownloadIcon" size="14" class="mr-50" />
              Descargar plantilla
            </b-button>
          </div>
        </div>
      </b-card-body>
    </b-card>

    <!-- URLs -->
    <b-card no-body class="upload-card mb-1">
      <b-card-header class="upload-card-header">
        <div class="d-flex align-items-center">
          <div class="upload-icon upload-icon-urls mr-1">
            <feather-icon icon="LinkIcon" size="18" />
          </div>
          <div>
            <h5 class="mb-0">URLs</h5>
            <small class="text-muted">URLs multiidioma (en, fr, de, it, es)</small>
          </div>
        </div>
      </b-card-header>
      <b-card-body class="pt-1">
        <b-row class="align-items-center">
          <b-col cols="12" md="9">
            <b-form-file
              v-model="csvUrls"
              placeholder="Selecciona un archivo CSV o arrástralo aquí..."
              drop-placeholder="Suelta el archivo aquí..."
              class="upload-file-input"
            />
          </b-col>
          <b-col cols="12" md="3" class="mt-1 mt-md-0">
            <b-button variant="warning" block @click="addUrls" class="upload-btn">
              <feather-icon icon="UploadIcon" size="16" class="mr-50" />
              Procesar
            </b-button>
          </b-col>
        </b-row>
        <div class="text-center mt-1">
          <span class="btn-ejemplo" @click="viewSampleUrls = !viewSampleUrls">
            <feather-icon :icon="viewSampleUrls ? 'ChevronUpIcon' : 'ChevronDownIcon'" size="14" class="mr-25" />
            Ver ejemplo
          </span>
        </div>
        <div v-if="viewSampleUrls" class="sample-section mt-1">
          <b-table responsive="sm" :items="itemsSampleUrls" striped small class="sample-table" />
          <div class="text-center">
            <b-button variant="flat-primary" size="sm" @click="downloadTemplateUrls">
              <feather-icon icon="DownloadIcon" size="14" class="mr-50" />
              Descargar plantilla
            </b-button>
          </div>
        </div>
      </b-card-body>
    </b-card>

    <!-- SKU Medidas -->
    <b-card no-body class="upload-card mb-1">
      <b-card-header class="upload-card-header">
        <div class="d-flex align-items-center">
          <div class="upload-icon upload-icon-medidas mr-1">
            <feather-icon icon="MaximizeIcon" size="18" />
          </div>
          <div>
            <h5 class="mb-0">SKU Medidas</h5>
            <small class="text-muted">Copia las 3 columnas del Excel y pulsa Procesar</small>
          </div>
        </div>
      </b-card-header>
      <b-card-body class="pt-1">
        <div class="clipboard-info mb-1">
          <feather-icon icon="ClipboardIcon" size="16" class="mr-50" />
          Las medidas se leen directamente del portapapeles (Ctrl+C desde Excel)
        </div>
        <div class="text-center">
          <b-button variant="info" @click="addMedidas" class="upload-btn px-3">
            <feather-icon icon="ClipboardIcon" size="16" class="mr-50" />
            Procesar Medidas
          </b-button>
        </div>
        <div class="text-center mt-1">
          <span class="btn-ejemplo" @click="viewSampleSkuMedidas = !viewSampleSkuMedidas">
            <feather-icon :icon="viewSampleSkuMedidas ? 'ChevronUpIcon' : 'ChevronDownIcon'" size="14" class="mr-25" />
            Ver ejemplo
          </span>
        </div>
        <div v-if="viewSampleSkuMedidas" class="sample-section mt-1">
          <b-table responsive="sm" :items="itemsSampleSkuMedidas" striped small class="sample-table" />
          <div class="text-center">
            <b-button variant="flat-primary" size="sm" @click="downloadTemplateSkuMedidas">
              <feather-icon icon="DownloadIcon" size="14" class="mr-50" />
              Descargar plantilla
            </b-button>
          </div>
        </div>
      </b-card-body>
    </b-card>

    <!-- Categorias (oculto) -->
    <b-card no-body class="upload-card mb-1" v-if="false">
      <b-card-header class="upload-card-header">
        <div class="d-flex align-items-center">
          <div class="upload-icon upload-icon-urls mr-1">
            <feather-icon icon="TagIcon" size="18" />
          </div>
          <h5 class="mb-0">Categorías</h5>
        </div>
      </b-card-header>
      <b-card-body class="pt-1">
        <b-row class="align-items-center">
          <b-col cols="12" md="9">
            <b-form-file
              v-model="csvCategorias"
              placeholder="Selecciona un archivo CSV o arrástralo aquí..."
              drop-placeholder="Suelta el archivo aquí..."
              class="upload-file-input"
            />
          </b-col>
          <b-col cols="12" md="3" class="mt-1 mt-md-0">
            <b-button variant="primary" block @click="procesarCategorias" class="upload-btn">
              <feather-icon icon="UploadIcon" size="16" class="mr-50" />
              Procesar
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <!-- Precios Sku (oculto) -->
    <b-card no-body class="upload-card mb-1" v-if="false">
      <b-card-header class="upload-card-header">
        <div class="d-flex align-items-center">
          <div class="upload-icon upload-icon-ventas mr-1">
            <feather-icon icon="DollarSignIcon" size="18" />
          </div>
          <h5 class="mb-0">Precios SKU</h5>
        </div>
      </b-card-header>
      <b-card-body class="pt-1">
        <b-row class="align-items-center">
          <b-col cols="12" md="9">
            <b-form-file
              v-model="csvPrecios"
              placeholder="Selecciona un archivo CSV o arrástralo aquí..."
              drop-placeholder="Suelta el archivo aquí..."
              class="upload-file-input"
            />
          </b-col>
          <b-col cols="12" md="3" class="mt-1 mt-md-0">
            <b-button variant="primary" block @click="procesarPrecios" class="upload-btn">
              <feather-icon icon="UploadIcon" size="16" class="mr-50" />
              Procesar
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

</div>
</template>


<script>
import axios from '@axios'
import vSelect from 'vue-select'
import BCardCode from '@core/components/b-card-code'
import { BRow, BCol, BFormFile, BButton  } from 'bootstrap-vue'
import { BTable } from 'bootstrap-vue'


export default {

  components: {
        BCardCode,
        BRow,
        BCol,
        BFormFile,
        BButton,
        vSelect,
        BTable
    },

  data(){
    return{
      csvInput: [],
      csvVentaDiaria: [],
      csvVisitaDiaria: [],
      csvUrls: [],
      csvVisitaMensual: [],
      csvStockMensual: [],
      csvCategorias: [],
      csvPrecios: [],
      listadoProductos: [],
      listadoSku: [],
      res: [],
      meses:[  
        { text: 'Enero', value: 1 },
        { text: 'Febrero', value: 2 },
        { text: 'Marzo', value: 3 },
        { text: 'Abril', value: 4 },
        { text: 'Mayo', value: 5 },
        { text: 'Junio', value: 6 },
        { text: 'Julio', value: 7 },
        { text: 'Agosto', value: 8 },
        { text: 'Septiembre', value: 9 },
        { text: 'Octubre', value: 10 },
        { text: 'Noviembre', value: 11 },
        { text: 'Diciembre', value: 12 }
        ],
      mesSeleccionado: '',
      anyos: [2019,2020,2021,2022,2023],
      anyoSeleccionado: '',
      articulosMedidas: [],
      
      lastUpdateVentaMensual: "",
      viewSampleVentaMensual: false,
      itemsSampleVentaMensual: [
        { month: '2023-03', variant_sku: 'FOLIO-EVO-MACAIR13-TAN', ordered_item_quantity: '1', gross_sales: '129', discounts: '0', returns: '0', net_sales: '129', taxes: '0', total_sales: '129'},
        { month: '2023-03', variant_sku: 'SLIM-NO7-MACPRO13-TAN', ordered_item_quantity: '4', gross_sales: '344.75', discounts: '-32.49', returns: '0', net_sales: '312.26', taxes: '46.57', total_sales: '358.83' }
      ],

      itemsSampleVMen: [
        { month: '2023-03', variant_sku: 'FOLIO-EVO-MACAIR13-TAN', ordered_item_quantity: '1', gross_sales: '129', discounts: '0', returns: '0', net_sales: '129', taxes: '0', total_sales: '129'},
        { month: '2023-03', variant_sku: 'SLIM-NO7-MACPRO13-TAN', ordered_item_quantity: '4', gross_sales: '344.75', discounts: '-32.49', returns: '0', net_sales: '312.26', taxes: '46.57', total_sales: '358.83' }
      ],

      //fecha, sku, cantidad, bruto_ventas, descuentos, devoluciones, neto_ventas, tasas, total_ventas, cantidad_neto
      
      lastUpdateVentaDiaria: "",
      viewSampleVentaDiaria: false,
      itemsSampleVentaDiaria: [
        { fecha: '2023-01-04', sku: 'FOLIO-EVO-MACAIR13-TAN', cantidad: '1', bruto_ventas: '129', descuentos: '0', devoluciones: '0', neto_ventas: '129', tasas: '0', total_ventas: '129', cantidad_neto: '129'},
        { fecha: '2023-01-05', sku: 'SLIM-NO7-MACPRO13-TAN', cantidad: '2', bruto_ventas: '220', descuentos: '0', devoluciones: '0', neto_ventas: '220', tasas: '0', total_ventas: '220', cantidad_neto: '220'},
      ],

      lastUpdateVisitaDiaria: "",
      viewSampleVisitaDiaria: false,
      itemsSampleVisitaDiaria: [
        { page_type: 'Product', page_path: '/products/laptop-briefcase', day: '2021-11-21', total_visitors: '1587', total_sessions: '1636', total_carts: '29', total_checkouts: '17', total_conversion: '0.01', total_orders_placed: '2', avg_duration: '53s', total_bounce_ratio: '0.66', total_pageviews: '3847' },
        { page_type: 'Product', page_path: '/products/work-briefcase', day: '2019-10-27', total_visitors: '1495', total_sessions: '1536', total_carts: '17', total_checkouts: '1', total_conversion: '0.01', total_orders_placed: '1', avg_duration: '43s', total_bounce_ratio: '0.81', total_pageviews: '2284' },
      ],
      
      //en, fr, de, it, es
      lastUpdateUrls: "",
      viewSampleUrls: false,
      itemsSampleUrls: [
        { en: 'url en ingles', fr: 'url en frances', de: 'url en aleman', it: 'url en italiano', es: 'url en español'},        
      ],
            
      lastUpdateVisitasMensuales: "",
      viewSampleVisitasMensuales: false,
      itemsSampleVisitasMensuales: [
        { page_type: 'Product', page_path: '/products/laptop-briefcase', month: '2022-11', total_visitors: '1587', total_sessions: '1636', total_carts: '29', total_checkouts: '17', total_conversion: '0.01', total_orders_placed: '2', avg_duration: '53s', total_bounce_ratio: '0.66', total_pageviews: '3847' },
        { page_type: 'Product', page_path: '/products/work-briefcase', month: '2022-11', total_visitors: '1495', total_sessions: '1536', total_carts: '17', total_checkouts: '1', total_conversion: '0.01', total_orders_placed: '1', avg_duration: '43s', total_bounce_ratio: '0.81', total_pageviews: '2284' },
      ],
      
      lastUpdateStockMensual: "",
      viewSampleStockMensual: false,
      itemsSampleStockMensuales: [
        { month: '2023-01', product_variant_sku: 'ROLLUP-MINI-WRAP-NAVY', variant_id: '40764749086831', ending_quantity: '51'},
        { month: '2023-01', product_variant_sku: 'PULL-CASE-7PLUS-BLK', variant_id: '40764744401007', ending_quantity: '9'},
      ],

      lastUpdateSkuMedidas: "",
      viewSampleSkuMedidas: false,
      itemsSampleSkuMedidas: [
        { sku: 'ENV-MAGNET-SLEEVE-MACPRO13', size: 'es indiferente este dato', dimensiones: '33.1 x 24.5 cm | 13.03 x 9.64"'},
        { sku: 'ENV-MAGNET-SLEEVE-MACPRO14', size: 'es indiferente este dato', dimensiones: '34.4 x 25.5 cm | 13.54 x 10.03"'},
      ],
    }
  },
  methods:{
    loadItems(){

      /*axios
        .get("/kpi/hsbc")
        .then(response => {
            return response.data;
        })
        .then(res => {
          console.log(res);
        });

        return;*/



      axios.post("/uso", {seccion:"upload"});

      axios
        .get("/options/return")
        .then(response => {
            return response.data;
        })
        .then(res => {
          //console.log(res);
        });

      axios
        .get("/medidas/variants")
        .then(response => {
            return response.data;
        })
        .then(resArticulos => {
            this.articulosMedidas = resArticulos;
        });

      /*Inicio Last update*/
      axios
        .get("/ventas/mensual/last")
        .then(response => {
            return response.data;
        })
        .then(res => {
            this.lastUpdateVentaMensual = res.anyo + "-" + res.mes;
            if(res.mes  < 10)
              this.lastUpdateVentaMensual = res.anyo + "-0" + res.mes;
        });

      axios
        .get("/ventas/diaria/last")
        .then(response => {
            return response.data;
        })
        .then(res => {
            this.lastUpdateVentaDiaria = res.fecha.split('T')[0];
        });

      axios
        .get("/visitas/diaria/last")
        .then(response => {
            return response.data;
        })
        .then(res => {
            this.lastUpdateVisitaDiaria = res.fecha.split('T')[0];
        });

      axios
        .get("/visitas/mensual/last")
        .then(response => {
            return response.data;
        })
        .then(res => {
              this.lastUpdateVisitasMensuales = res.anyo + "-" + res.mes;
            if(res.mes  < 10)
              this.lastUpdateVisitasMensuales = res.anyo + "-0" + res.mes;
        });

      axios
        .get("/articulos/sku/stock/noviembre/last")
        .then(response => {
            return response.data;
        })
        .then(res => {
            this.lastUpdateStockMensual = res.anyo;
        });
      /*Fin Last update*/


      axios
        .get("/shopify/products")
        .then(response => {
            return response.data;
        })
        .then(res => {
          this.listadoProductos = res;

          //this.downloadJsonProductsAmazon();
        });

        axios
            .get("/finanzas/articulos")
            .then(response => {
                return response.data;
            })
            .then(res => {
              
              this.listadoSku = res;
  
            });

    },
    downloadJsonProductsAmazon() {

      const getShopifyImageUrl = (input) => {
        const baseCDN = 'https://cdn.shopify.com/s/files/1/0653/3919/files/';
        return input?.startsWith('shopify://shop_images/')
          ? input.replace('shopify://shop_images/', baseCDN)
          : input || '';
      };

      const requireTemplate = require.context('@/assets/templates/', false, /\.json$/);

      const templates = {};

      requireTemplate.keys().forEach(filename => {
        const key = filename.replace('./', '').replace('.json', '');
        templates[key] = requireTemplate(filename);
      });

      let csv = "EAN@SKU@Features@Handmade By Us@Materials@Delivery@Specs@Sustainability@Texto bloque 1@Texto bloque 2@Imagen adicional 1@Texto Imagen adicional 1@Imagen adicional 2@Texto Imagen adicional 2@Imagen adicional 3@Texto Imagen adicional 3@Imagen adicional 4@Texto Imagen adicional 4@Imagen adicional 5@Imagen adicional 6@Imagen adicional 7@URL Video Ficha producto\n";

      this.listadoProductos.forEach((producto, index) => {

        if(index == 0 || true){
          const jsonDataPath = 'product.' + producto.template_suffix;
          const data = templates[jsonDataPath];

          if (!data) {
            console.warn(`No se encontró template para ${jsonDataPath} | ${producto.title}`);
            return;
          }

          /*console.log(data);
          console.log(producto);*/

          // Mapear acordeones
          const accordionMap = {
            "Features": '',
            "Handmade By Us": '',
            "Materials": '',
            "Delivery": '',
            "Specs": '',
            "Sustainability": '',
          };

          const mainBlocks = data.sections.main?.blocks || {};
          const blockOrder = data.sections.main?.block_order || [];

          blockOrder.forEach(blockId => {
            const block = mainBlocks[blockId];
            if (block?.type === 'accordion') {
              const title = block.settings.title_accordion1?.trim();
              //console.log(title);
              const content = block.settings.text_accordion1?.trim();
              if (accordionMap.hasOwnProperty(title)) {
                accordionMap[title] = content || '';
              }
            }
          });

          // Extraer bloques tipo texto + imagen
          const textoBloques = [];
          const imagenes = [];
          let videoURL = '';

          data.order.forEach(sectionId => {
            const section = data.sections[sectionId];

            if (section?.type === 'image-text') {
              const titulo = section.settings.title || '';
              const texto = section.settings.text || '';
              textoBloques.push(`${titulo}\n${texto}`);
              imagenes.push(getShopifyImageUrl(section.settings.image));
            }

            if (section?.type === 'text-over-image') {
              const titulo = section.settings.title_toi || '';
              const subtitulo = section.settings.subtitle_toi || '';
              textoBloques.push(`${titulo} - ${subtitulo}`);
              imagenes.push(getShopifyImageUrl(section.settings.image));
            }


            if (section?.type === 'featured-video') {
              const blocks = section.blocks || {};
              const blockIds = section.block_order || Object.keys(blocks);

              for (const blockId of blockIds) {
                const block = blocks[blockId];
                if (block?.type === 'video') {
                  videoURL = block.settings.url_video || '';
                  break;
                }
              }
            }
          });

         

          // Construir línea CSV por variante
          producto.variants.forEach(variant => {
            const campos = [
              variant.barcode || '',
              variant.sku || '',
              accordionMap["Features"] || '',
              accordionMap["Handmade By Us"] || '',
              accordionMap["Materials"] || '',
              accordionMap["Delivery"] || '',
              accordionMap["Specs"] || '',
              accordionMap["Sustainability"] || '',
              textoBloques[0] || '',
              textoBloques[1] || '',
              imagenes[0] || '',
              textoBloques[0] || '',
              imagenes[1] || '',
              textoBloques[1] || '',
              imagenes[2] || '',
              textoBloques[2] || '',
              imagenes[3] || '',
              textoBloques[3] || '',
              imagenes[4] || '',
              imagenes[5] || '',
              imagenes[6] || '',
              videoURL || ''
            ];

            const fila = campos.map(c => c?.replace(/[\n\r@]/g, ' ').trim()).join('@');

            if(variant.barcode &&  variant.sku )
              csv += fila + '\n';
          });
        }
      });

      navigator.clipboard.writeText(csv)
        .then(() => {
          console.log("Texto copiado al portapapeles");
        })
        .catch(err => {
          console.error("Error al copiar: ", err);
        });
      
      // Descargar como archivo CSV (puedes reemplazar por copiar al portapapeles si prefieres)
      /*const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', 'productos_amazon.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);*/
    },
    downloadJsonProductsAmazon2(){
      const requireTemplate = require.context('@/assets/templates/', false, /\.json$/);

      const templates = {};

      requireTemplate.keys().forEach(filename => {
        const key = filename.replace('./', '').replace('.json', '');
        templates[key] = requireTemplate(filename);
      });


      let csv = "EAN@SKU@Features@Handmade by us@Materials@Delivery@Specs@Texto bloque 1@Texto bloque 2@Imagen adicional 1@Texto Imagen adicional 1@Imagen adicional 2@Texto Imagen adicional 2@Imagen adicional 3@Texto Imagen adicional 3@Imagen adicional 4@Texto Imagen adicional 4@Imagen adicional 5@Imagen adicional 6@Imagen adicional 7@URL Video Ficha producto\n";
      
      //console.log(templates);

      this.listadoProductos.forEach((producto, index) => {

        let jsonDataPath = 'product.'+producto.template_suffix;

        if(index == 0)
        {
          const data = templates[jsonDataPath];
          console.log(data);
          console.log(producto);

          producto.variants.forEach(variant =>{
            csv += `${variant.barcode}@${variant.sku}@Features@$`;
          });

         
        }
          //console.log(jsonDataPath);
      });

      /*navigator.clipboard.writeText(csv)
        .then(() => {
          console.log("Texto copiado al portapapeles");
        })
        .catch(err => {
          console.error("Error al copiar: ", err);
        });*/
      //this.downloadCSV(csv,"ventaMensualTemplate")
    },
    addVentaMensual(){

      var reader = new FileReader();
      var self = this;
      reader.onload = (e) => {
        let data = reader.result.split(/\r?\n/);

        let dataExport = [];

        data.forEach(line => {

          if(line != null)
          {
            dataExport.push(line);
          }

        });

        let info = { articulos: dataExport}

        axios
          .post("/ventas/mensual/csv", info)
          .then(response => {
              return response.data;
          })
          .then(res => {
            this.$bvToast.toast(`Se ha subido el csv correctamente`, {
                  title: 'Venta Mensual',
                  variant: 'success',
                  solid: true,
                })

                axios
                  .get("/ventas/mensual/last")
                  .then(response => {
                      return response.data;
                  })
                  .then(resUpdate => {
                      this.lastUpdateVentaMensual = resUpdate.anyo + "-" + resUpdate.mes;
                      if(resUpdate.mes  < 10)
                        this.lastUpdateVentaMensual = resUpdate.anyo + "-0" + resUpdate.mes;
                  });
          });

        self.res = data;
      }

        reader.readAsText(this.csvInput);
    },
    addVentaDiaria(){

      var reader = new FileReader();
      var self = this;
      reader.onload = (e) => {
        let data = reader.result.split(/\r?\n/);

        //console.log(data);

        let dataExport = [];

        data.forEach(line => {

          if(line != null)
          {
            dataExport.push(line);
          }
          
        });

        let info = { articulos: dataExport}

        axios
          .post("/ventas/diaria/csv", info)
          .then(response => {
              return response.data;
          })
          .then(res => {
            this.$bvToast.toast(`Se ha subido el csv correctamente`, {
                  title: 'Venta Diaria',
                  variant: 'success',
                  solid: true,
                })

              axios
                .get("/ventas/diaria/last")
                .then(response => {
                    return response.data;
                })
                .then(resUpdate => {
                    this.lastUpdateVentaDiaria = resUpdate.fecha.split('T')[0];
                });
          });

        self.res = data;
      }
      /*if(this.csvVentaDiaria.length > 0)
      {
        console.log("entro aqui");
        reader.readAsText(this.csvVentaDiaria[0]);
      }*/
      reader.readAsText(this.csvVentaDiaria);
    },
    addVisitaDiaria(){
      var reader = new FileReader();
      var self = this;
      reader.onload = (e) => {
        let data = reader.result.split(/\r?\n/);

        let dataExport = [];

        data.forEach(line => {

          if(line != null)
          {
            try {

              if(line.includes("Product"))
                dataExport.push(line);
              
            } catch (error) {
              
            }
          
          }
          
        });

         axios
          .get("/visitas/urls")
          .then(response => {
              return response.data;
          })
          .then(res => {
            //console.log(res);

            let info = { visitas: []}

            dataExport.forEach(data => {

              let path = data.split(',')[1];

              let obj = res.find(u => {
                if(u.fr.split('/').pop() == path.split('/').pop() || 
                u.de.split('/').pop() == path.split('/').pop() || 
                u.it.split('/').pop() == path.split('/').pop() || 
                u.es.split('/').pop() == path.split('/').pop() )
                  return true;
              });

              //"https://www.harberlondon.com/products/super-slim-cardholder-with-rfid-protection"

              if(obj != null)
                data = data.replace(path,obj.en.split('/').pop())
              else
                data = data.replace('/products/','')

              info.visitas.push(data);

            });

             console.log(info);
            return;

            axios
              .post("/visitas/diaria/csv", info)
              .then(response => {
                  return response.data;
              })
              .then(res => {
                this.$bvToast.toast(`Se ha subido el csv correctamente`, {
                  title: 'Visita Diaria',
                  variant: 'success',
                  solid: true,
                })

                axios
                  .get("/visitas/diaria/last")
                  .then(response => {
                      return response.data;
                  })
                  .then(resUpdate => {
                      this.lastUpdateVisitaDiaria = resUpdate.fecha.split('T')[0];
                  });
              });
          });

      }
      /*if(this.csvVentaDiaria.length > 0)
      {
        console.log("entro aqui");
        reader.readAsText(this.csvVentaDiaria[0]);
      }*/
      reader.readAsText(this.csvVisitaDiaria);
    },
    addVisitaMensual(){

      var reader = new FileReader();
      var self = this;
      reader.onload = (e) => {
        let data = reader.result.split(/\r?\n/);

        let dataExport = [];

        data.forEach(line => {

          if(line != null)
          {
            try {

              if(line.includes("Product"))
                dataExport.push(line);
              
            } catch (error) {
              
            }
          
          }
          
        });

         axios
          .get("/visitas/urls")
          .then(response => {
              return response.data;
          })
          .then(res => {
            //console.log(res);

            let info = { visitas: []}

            dataExport.forEach(data => {

              let path = data.split(',')[1];

              let obj = res.find(u => {
                if(u.fr.split('/').pop() == path.split('/').pop() || 
                u.de.split('/').pop() == path.split('/').pop() || 
                u.it.split('/').pop() == path.split('/').pop() || 
                u.es.split('/').pop() == path.split('/').pop() )
                  return true;
              });

              //"https://www.harberlondon.com/products/super-slim-cardholder-with-rfid-protection"

              if(obj != null)
                data = data.replace(path,obj.en.split('/').pop())
              else
                data = data.replace('/products/','')

              info.visitas.push(data);

            });

            console.log(info);
            return;

            axios
              .post("/visitas/mensual/csv", info)
              .then(response => {
                  return response.data;
              })
              .then(res => {
                this.$bvToast.toast(`Se ha subido el csv correctamente`, {
                  title: 'Visita Mensual',
                  variant: 'success',
                  solid: true,
                })

                axios
                  .get("/visitas/mensual/last")
                  .then(response => {
                      return response.data;
                  })
                  .then(resUpdate => {
                        this.lastUpdateVisitasMensuales = resUpdate.anyo + "-" + resUpdate.mes;
                      if(resUpdate.mes  < 10)
                        this.lastUpdateVisitasMensuales = resUpdate.anyo + "-0" + resUpdate.mes;
                  });
              });
          });

        

      }
      /*if(this.csvVentaDiaria.length > 0)
      {
        console.log("entro aqui");
        reader.readAsText(this.csvVentaDiaria[0]);
      }*/
      reader.readAsText(this.csvVisitaMensual);
    },
    addStockMensual(){

      var reader = new FileReader();
      var self = this;
      reader.onload = (e) => {
        let data = reader.result.split(/\r?\n/);

        let dataExport = [];

        data.forEach(line => {

          if(line != null)
          {
                dataExport.push(line);
          }
          
        });


        let info = { articulos: dataExport}

        axios
          .post("/articulos/stock/csv/noviembre", info)
          .then(response => {
              return response.data;
          })
          .then(res => {
            this.$bvToast.toast(`Se ha subido el csv correctamente`, {
                  title: 'Stock Noviembre',
                  variant: 'success',
                  solid: true,
                })
           
          }).catch(error => {
            this.$bvToast.toast(`Error al subir el csv quizas no hayas seleccionado noviembre`, {
                  title: 'Error',
                  variant: 'danger',
                  solid: true,
                })
          });


        //Stock Antiguo
        /*axios
          .post("/articulos/stock/csv", info)
          .then(response => {
              return response.data;
          })
          .then(res => {
            this.$bvToast.toast(`Se ha subido el csv correctamente`, {
                  title: 'Stock Mensual',
                  variant: 'success',
                  solid: true,
                })

            axios
                .get("/articulos/sku/stock/mensual/last")
                .then(response => {
                    return response.data;
                })
                .then(resUpdate => {
                    this.lastUpdateStockMensual = resUpdate.fecha.split('-')[0]+'-'+resUpdate.fecha.split('-')[1];
                });
          });*/
   

        

      }

      reader.readAsText(this.csvStockMensual);
    },
    addUrls(){

      var reader = new FileReader();
      var self = this;
      reader.onload = (e) => {
        let data = reader.result.split(/\r?\n/);

        let dataExport = [];

        data.forEach(line => {

          if(line != null)
          {
            dataExport.push(line);
          }
          
        });

        let info = { urls: dataExport}

        axios
          .post("/visitas/url/csv", info)
          .then(response => {
              return response.data;
          })
          .then(res => {
            this.$bvToast.toast(`Se ha subido el csv correctamente`, {
                  title: 'Urls',
                  variant: 'success',
                  solid: true,
                })
          });
      }

      reader.readAsText(this.csvUrls);
    },
    procesarCategorias(){

      var reader = new FileReader();
      var self = this;
      reader.onload = (e) => {
        let data = reader.result.split(/\r?\n/);

        let dataExport = [];

        data.forEach(line => {

          if(line != null)
          {
            dataExport.push(line);
          }
          
        });

        //console.log(dataExport);

        let csv = "All Keywords,Bags,Sleeves,Wallets,Accessories\n";

        dataExport.forEach(item => {

          if((item.includes('bag') || item.includes('backpack') || item.includes('briefcase') || item.includes('back') || item.includes('ruck'))  && !item.includes('desk') && !item.includes('wallet'))//bags
          {
            csv += `${item},${item},,,\n`
          }
          else if((item.includes('case') || item.includes('laptop') || item.includes('sleeve') || item.includes('cover'))  && !item.includes('briefcase') && !item.includes('wallet'))//sleeves
          {
            csv += `${item},,${item},,\n`
          }
          else if((item.includes('wallet') || item.includes('card') || item.includes('passport') || item.includes('billeteras')) && !item.includes('desk'))//wallets
          {
            csv += `${item},,,${item},\n`
          }
          else //Accesories
          {
            csv += `${item},,,,${item}\n`
          }

        });

        this.downloadCSV(csv,"csvCategorias")

      }

      reader.readAsText(this.csvCategorias);
    },
    procesarPrecios(){

      //console.log('procesar precios');

      var reader = new FileReader();
      var self = this;
      reader.onload = (e) => {
        let data = reader.result.split(/\r?\n/);

        let dataExport = [];

        data.forEach(line => {

          if(line != null)
          {
            dataExport.push(line.split(','));
          }
          
        }); 

        //console.log(dataExport);

        dataExport.forEach(item => {

          let multi = 0.155;

          if(item[0] == 'Bags')
            multi = 0.215;

          let dataSku = {
              nombre: item[1], 
              sku: item[2], 
              confeccion: 0, 
              ubrique: '0',
              materiales: item[4],
              packaging: item[6],
              shipping: item[7],
              rrp: item[9],
              roas: '',
              hsCode: '',
              rrpE: '0',
              total: '',
              multiplicador: multi,
              exchange: '1.17',
            };

          this.listadoProductos.some(producto => {
            const varianteEncontrada = producto.variants.find(variante => variante.sku && variante.sku.includes(dataSku.sku));
            if (varianteEncontrada) {
              dataSku.rrp = varianteEncontrada.price;
            }
          });

          dataSku.rrpE = parseFloat(dataSku.rrp * 1.17).toFixed(2);
          dataSku.confeccion = (parseFloat(dataSku.rrpE ) * parseFloat(multi)).toFixed(2);
          dataSku.total =  (parseFloat(dataSku.confeccion) + parseFloat(dataSku.materiales)).toFixed(2);
          dataSku.roas = parseFloat(((parseFloat(dataSku.rrpE) - (parseFloat(dataSku.total ) + parseFloat(dataSku.packaging ) + parseFloat(dataSku.shipping ))) / parseFloat(dataSku.rrpE)) * 100).toFixed(2);

          if(isNaN(dataSku.roas))
          {
            dataSku.roas = 0;
          }

          let skuEncontrado = this.listadoSku.find(sku => sku.sku == dataSku.sku);

          if(skuEncontrado){
            dataSku.id = skuEncontrado.id;
            dataSku.ubrique = skuEncontrado.ubrique;

            axios
              .put("/finanzas/articulo/precio", dataSku)
              .then(response => {
                return response.data;
              })
              .then(res => { 
                                
            });
          }
          else{

            axios
              .post("/finanzas/articulo/precio", dataSku)
              .then(response => {
                return response.data;
              })
              .then(res => {

              });

          }



          /*axios
            .post("/finanzas/articulo/precio", dataSku)
            .then(response => {
              return response.data;
            })
            .then(res => {

            });*/

            /* axios
              .put("/finanzas/articulo/precio", data)
              .then(response => {
                return response.data;
              })
              .then(res => { 
                
                
            });*/

            //console.log(dataSku);

        });

            

            //dataSku

        

        

       //console.log(dataExport);

      }

      reader.readAsText(this.csvPrecios);
    },
    addMedidas(){

      navigator.clipboard.readText()
        .then(texto => {
          let textoEnLineas = texto.split(/\r\n|\r|\n/, -1);

          let numProcesado = 0;

          let listSkuProcesados = [];

          textoEnLineas.forEach(linea => {

            let columnas = linea.split("\t");

            if(columnas.length == 3)
            {
              let sku = columnas[0];
              let medidas = columnas[2];

              if(medidas.includes("cm"))
              {

                let ancho = medidas.split("cm")[0].split("x")[0];
                let alto = medidas.split("cm")[0].split("x")[1];

                ancho = ancho.replaceAll(" ","");
                alto = alto.replaceAll(" ","");

                this.articulosMedidas.forEach(articulo => {

                  if(articulo.sku.includes(sku))
                  {

                     let infoMedidas = {
                      sku: articulo.sku,
                      ancho: ancho,
                      alto: alto,
                      profundo: '',
                      product: articulo.product,
                    }

                    if(!listSkuProcesados.includes(articulo.sku))
                    {

                       listSkuProcesados.push(articulo.sku);

                        numProcesado++;

                        axios
                          .post("/medidas", infoMedidas)
                          .then(response => {
                              return response.data;
                          })
                          .then(res => {
                          });

                          }
                    }

                });   

              }
            }

          });

          if(numProcesado > 0)
          {
            this.$bvToast.toast(`Se han subido ${numProcesado} medidas`, {
                  title: 'Medidas Subidas',
                  variant: 'success',
                  solid: true,
                })
          }
          else
          {
            this.$bvToast.toast(`No se han encontrado medidas`, {
                  title: 'Medidas',
                  variant: 'danger',
                  solid: true,
                })
          }

        })
        .catch(error => {
          console.log("Hubo un error: ", error);
           this.$bvToast.toast(`No se ha podido acceder al portapapeles`, {
                  title: 'Medidas',
                  variant: 'danger',
                  solid: true,
                })
        });

    },
    downloadTemplateVentaMensual(){
      let csv = "month,variant_sku,ordered_item_quantity,gross_sale,discounts,returns,net_sales,taxes,total_sales";
      this.downloadCSV(csv,"ventaMensualTemplate")
    },
    downloadTemplateVentaDiaria(){
      let csv = "fecha,sku,cantidad,bruto_ventas,descuentos,devoluciones,neto_ventas,tasas,total_ventas,cantidad_neto";
      this.downloadCSV(csv,"ventaDiariaTemplate")
    },
    downloadTemplateVisitaDiaria(){
      let csv = "page_type,page_path,day,total_visitors,total_sessions,total_carts,total_checkouts,total_conversion,total_orders_placed,avg_duration,total_bounce_rate,total_pageviews";
      this.downloadCSV(csv,"visitaDiariaTemplate")
    },
    downloadTemplateUrls(){
      let csv = "en,fr,de,it,es";
      this.downloadCSV(csv,"urlsTemplate")
    },
    downloadTemplateVisitaMensuales(){
      let csv = "page_type,page_path,month,total_visitors,total_sessions,total_carts,total_checkouts,total_conversion,total_orders_placed,avg_duration,total_bounce_rate,total_pageviews";
      this.downloadCSV(csv,"ventaDiariaTemplate")
    },
    downloadTemplateStockMensual(){
      let csv = "month,product_variant_sku,ending_quantity";
      this.downloadCSV(csv,"stockMensualTemplate")
    },
    downloadTemplateSkuMedidas(){
      let csv = "sku,size,dimensiones";
      this.downloadCSV(csv,"skuMedidasTemplate")
    },
    downloadCSV(csv, name)
    {
      var encodedUri = encodeURI(csv);
      var link = document.createElement("a");
      link.setAttribute("href", 'data:text/csv;charset=utf-8,'+encodedUri);
      link.setAttribute("download",name+".csv");
      document.body.appendChild(link); 
      link.click();
    }

  },
  mounted() {    
      this.loadItems();
  },
  
}
</script>

<style lang="scss">
@import '../@core/scss/vue/libs/vue-select.scss';

.upload-page {

  .upload-header-card {
    border: none;
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);

    .icon-header {
      width: 46px;
      height: 46px;
      border-radius: 12px;
      background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
    }
  }

  .upload-card {
    border: none;
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
    transition: box-shadow 0.3s ease;

    &:hover {
      box-shadow: 0 4px 28px 0 rgba(34, 41, 47, 0.16);
    }

    .upload-card-header {
      border-bottom: 1px solid #f3f2f7;
      padding: 1.2rem 1.5rem;
    }

    .upload-icon {
      width: 36px;
      height: 36px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      flex-shrink: 0;
    }

    .upload-icon-ventas {
      background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%);
    }

    .upload-icon-visitas {
      background: linear-gradient(135deg, #00cfe8 0%, #4dd9ec 100%);
    }

    .upload-icon-stock {
      background: linear-gradient(135deg, #28c76f 0%, #48da89 100%);
    }

    .upload-icon-urls {
      background: linear-gradient(135deg, #ff9f43 0%, #ffb976 100%);
    }

    .upload-icon-medidas {
      background: linear-gradient(135deg, #ea5455 0%, #f08182 100%);
    }

    .upload-file-input {
      .custom-file-label {
        border-radius: 8px;
        border: 2px dashed #d8d6de;
        padding: 0.6rem 1rem;
        transition: border-color 0.2s;

        &:hover {
          border-color: #7367f0;
        }

        &::after {
          border-radius: 0 6px 6px 0;
          background: #f8f8f8;
          border-left: 1px solid #d8d6de;
          content: 'Examinar';
        }
      }
    }

    .upload-btn {
      border-radius: 8px;
      font-weight: 500;
      padding: 0.65rem 1rem;
      letter-spacing: 0.3px;
    }

    .btn-ejemplo {
      display: inline-flex;
      align-items: center;
      font-size: 0.85rem;
      color: #7367f0;
      cursor: pointer;
      transition: color 0.2s;
      user-select: none;

      &:hover {
        color: #5e50ee;
      }
    }

    .sample-section {
      background: #f8f8f8;
      border-radius: 8px;
      padding: 1rem;
      border: 1px solid #ebe9f1;

      .sample-table {
        font-size: 0.8rem;
        margin-bottom: 0.5rem;

        thead th {
          text-transform: uppercase;
          font-size: 0.7rem;
          letter-spacing: 0.3px;
          white-space: nowrap;
        }
      }
    }

    .clipboard-info {
      background: #e8f4fd;
      border: 1px solid #b8daff;
      border-radius: 8px;
      padding: 0.75rem 1rem;
      color: #004085;
      font-size: 0.875rem;
      display: flex;
      align-items: center;
    }
  }
}

// Modo oscuro
.dark-layout .upload-page {
  .upload-card .upload-card-header { border-bottom-color: #2c2c2c; }
  .upload-card .upload-file-input .custom-file-label {
    border-color: #3a3a3a;
    &::after { background: #242424; border-left-color: #2c2c2c; color: #d0d2d6; }
  }
  .upload-card .sample-section { background: #161616; border-color: #2c2c2c; }
  .upload-card .clipboard-info { background: rgba(59, 130, 246, 0.12); border-color: rgba(59, 130, 246, 0.35); color: #93c5fd; }
}
</style>